<template>
  <BasePageContainer class="template_add pt-3">
    <page-header
      has-back>
      テンプレートの追加
    </page-header>
    <div class="template_add__body general-form pt-8">
      <template-form
        v-model="templateFormData"
        @submit="onClickSave()" />
    </div>
  </BasePageContainer>
</template>

<script>
import PageHeader from '@/components/parts/PageHeader.vue'
import TemplateForm from '@/components/view/TemplateForm.vue'

export default {
  components: {
    PageHeader,
    TemplateForm
  },
  data() {
    return {
      templateFormData: {
        title: '',
        sortOrder: 0,
        color: '#000000',
        detail: '',
        category: null
      }
    }
  },
  methods: {
    async onClickSave(){
      this.$store.commit('startLoading')
      await this.$axios.post('/events/templates/', this.templateFormData).then(() => {
        this.$store.commit('notify/set', {message: 'テンプレートを作成しました'})
        this.$router.push('/admin/templates/')
      }).catch((e) => {
        console.error(e)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })

      this.$store.commit('finishLoading')
    },
    onClickCancel(){
      this.$router.push('/admin/templates/')
    }
  }

}
</script>

<style lang="scss" scoped>
.template_add-head{
  background-color: $l-blue;
  @media screen and (min-width:992px) {
    right: 0;
    left: 120px;
  }
  &__back{
    height: 22px;
    width: auto;
    color: $white;
    display: inline-block;
    vertical-align: text-bottom;
  }
  &__heading{
    color: $white;
    font-size: $fs-lg;
    font-weight: bold;
  }
}
.template_add{
  &__head{
    background-color: $primary;
    color: $white;
    border-radius: 8px;
  }
  &__img{
    object-fit: cover; 
    width: 60px;
    height: 60px;
    max-width: 60px;
    
  }
  &__name{
    font-weight: bold;
  }
  &__title{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
  &__team{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
}

.form-info{
  color: $grey09;
  &__logout{
    text-decoration: none;
    font-weight: bold;
    color: $grey09;
    font-size: $fs-m;
  }
  &__date{
    font-size: $fs-m;
  }
}
</style>